// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edm-apia-wrapper {
  font-size: 62.5%;
  font-size: 1.6rem;
  background-color: #e9e9e9;
  font-family: Arial, Tahoma;
  margin: 0px;
  /*===========================  Start Main Page  ===========================*/ }
  .edm-apia-wrapper h1,
  .edm-apia-wrapper h2,
  .edm-apia-wrapper h3,
  .edm-apia-wrapper h4,
  .edm-apia-wrapper h5,
  .edm-apia-wrapper h6,
  .edm-apia-wrapper p {
    margin: 0;
    padding: 0; }
  .edm-apia-wrapper ul {
    margin: 0;
    padding: 0;
    list-style: none; }
  .edm-apia-wrapper ul li a,
  .edm-apia-wrapper a {
    text-decoration: none; }
  .edm-apia-wrapper .main_page {
    max-width: 700px;
    margin: auto;
    background-color: #ffffff; }
  .edm-apia-wrapper .section_padding {
    padding: 0px 35px; }
  .edm-apia-wrapper .section_padding2 {
    padding: 0px 50px; }
  .edm-apia-wrapper .em_hide {
    display: none; }
  .edm-apia-wrapper .header_and_banner {
    background-color: #011562;
    background-image: url(https://tcncmpcardart.s3.ap-southeast-2.amazonaws.com/Tcncp/Suncorp/APIA/bg1.png);
    background-size: cover; }
  .edm-apia-wrapper .header {
    padding: 5px 0px 5px 0px; }
  .edm-apia-wrapper .header a img {
    width: 167px;
    height: auto; }
  .edm-apia-wrapper .header p {
    font-size: 15px;
    line-height: 19px;
    font-weight: normal;
    font-style: normal;
    color: #eb5d54;
    padding: 8px 0 8px 0; }
  .edm-apia-wrapper .banner_main img {
    width: 100%;
    height: auto; }
  .edm-apia-wrapper .banner_contents {
    padding: 34px 35px 35px 35px; }
  .edm-apia-wrapper .banner_contents h3 {
    font-size: 19px;
    line-height: 23px;
    font-weight: bold;
    font-style: normal;
    color: #00369c; }
  .edm-apia-wrapper .banner_contents p {
    font-size: 15px;
    line-height: 19px;
    font-weight: normal;
    font-style: normal;
    color: #000000;
    padding: 14px 0px 0px 0px; }
  .edm-apia-wrapper .redem_your_reward_main {
    background-color: #d6d5dc; }
  .edm-apia-wrapper .redem_your_reward_items_all {
    display: flex;
    justify-content: space-between;
    margin-top: 40px;
    flex-wrap: wrap; }
  .edm-apia-wrapper .redem_your_reward_title h2 {
    font-size: 25px;
    line-height: 30px;
    font-weight: bold;
    font-style: normal;
    color: #00369c;
    padding: 36px 0 0 0;
    text-align: center; }
  .edm-apia-wrapper .redem_your_reward_single {
    text-align: center;
    margin-bottom: 28px;
    display: flex;
    flex-direction: column;
    align-items: center; }
  .edm-apia-wrapper .redem_your_reward_single p {
    font-size: 12px;
    line-height: 16px;
    font-weight: normal;
    font-style: normal;
    color: #000000;
    padding: 11px 0 0 0;
    max-width: 125px; }
  .edm-apia-wrapper .redem_your_reward_textbtn p {
    font-size: 15px;
    line-height: 22px;
    font-weight: normal;
    font-style: normal;
    color: #000000; }
  .edm-apia-wrapper .redem_your_reward_textbtn p span {
    font-size: 15px;
    line-height: 22px;
    font-weight: bold;
    font-style: normal;
    color: #00369c; }
  .edm-apia-wrapper .redem_your_reward_btn a {
    width: 220px;
    background-color: #00369c;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    line-height: 20px;
    font-weight: bold;
    font-style: normal;
    color: #ffffff;
    padding: 13px 0 12px 0;
    transition: 0.2s; }
  .edm-apia-wrapper .redem_your_reward_btn a:hover {
    background-color: #4a79d3; }
  .edm-apia-wrapper .redem_your_reward_btn {
    display: flex;
    justify-content: center;
    padding: 30px 0px 40px 0px; }
  .edm-apia-wrapper .footer_all_contents {
    background-color: #d6d5dc;
    border-top: 40px solid #e9e9e9; }
  .edm-apia-wrapper .footer_contents_need_help p {
    font-size: 15px;
    line-height: 19px;
    font-weight: normal;
    font-style: normal;
    color: #000000; }
  .edm-apia-wrapper .footer_contents_need_help p span {
    color: #00369c;
    font-weight: bold; }
  .edm-apia-wrapper .footer_contents_need_help p:first-child {
    padding: 38px 0px 20px 0px; }
  .edm-apia-wrapper .footer_contents_need_help p:last-child {
    padding: 0px 0px 38px 0px; }
  .edm-apia-wrapper .from_the_brighter_reward_team {
    padding: 38px 35px 38px 35px;
    background-color: #00369c;
    background-image: url(https://tcncmpcardart.s3.ap-southeast-2.amazonaws.com/Tcncp/Suncorp/APIA/bg2.png);
    background-size: cover; }
  .edm-apia-wrapper .from_the_brighter_reward_team h2 {
    font-size: 18px;
    line-height: 22px;
    font-weight: bold;
    font-style: normal;
    color: #ffffff; }
  .edm-apia-wrapper .this_email_has_been {
    background-color: #e9e9e9;
    padding: 0px 45px 0px 45px; }
  .edm-apia-wrapper .this_email_has_been p {
    font-size: 11px;
    line-height: 15px;
    font-weight: normal;
    font-style: normal;
    color: #737373;
    padding: 34px 0px 34px 0px; }
  @media all and (max-width: 575px) {
    .edm-apia-wrapper .section_padding {
      padding: 0px 15px; }
    .edm-apia-wrapper .section_padding2 {
      padding: 0px 15px; }
    .edm-apia-wrapper .banner_contents {
      padding: 34px 15px 35px 15px; }
    .edm-apia-wrapper .banner_contents h3 {
      font-size: 17px;
      line-height: 21px; }
    .edm-apia-wrapper .redem_your_reward_title h2 {
      font-size: 20px;
      line-height: 24px; }
    .edm-apia-wrapper .redem_your_reward_items_all {
      margin-top: 40px;
      padding: 0px 25px; }
    .edm-apia-wrapper .from_the_brighter_reward_team {
      padding: 34px 15px 34px 15px; }
    .edm-apia-wrapper .from_the_brighter_reward_team h2 {
      font-size: 16px;
      line-height: 20px; } }
`, "",{"version":3,"sources":["webpack://./src/pages/custom-redeem/edm/apia/EdmApia.scss"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,0BAA0B;EAC1B,WAAW;EAoBX,4EAAA,EAA6E;EAzB/E;;;;;;;IAaI,SAAS;IACT,UAAU,EAAA;EAdd;IAiBI,SAAS;IACT,UAAU;IACV,gBAAgB,EAAA;EAnBpB;;IAuBI,qBAAqB,EAAA;EAvBzB;IA2BI,gBAAgB;IAChB,YAAY;IACZ,yBAAyB,EAAA;EA7B7B;IAgCI,iBAAiB,EAAA;EAhCrB;IAmCI,iBAAiB,EAAA;EAnCrB;IAsCI,aAAa,EAAA;EAtCjB;IA0CI,yBAAyB;IACzB,uGAAuG;IACvG,sBAAsB,EAAA;EA5C1B;IA+CI,wBAAwB,EAAA;EA/C5B;IAkDI,YAAY;IACZ,YAAY,EAAA;EAnDhB;IAsDI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,oBAAoB,EAAA;EA3DxB;IA+DI,WAAW;IACX,YAAY,EAAA;EAhEhB;IAmEI,4BAA4B,EAAA;EAnEhC;IAsEI,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc,EAAA;EA1ElB;IA6EI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,yBAAyB,EAAA;EAlF7B;IAsFI,yBAAyB,EAAA;EAtF7B;IA2FI,aAAa;IAGb,8BAA8B;IAC9B,gBAAgB;IAEhB,eAAe,EAAA;EAjGnB;IAoGI,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,kBAAkB,EAAA;EA1GtB;IA6GI,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,mBAAmB,EAAA;EAjHvB;IAoHI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,gBAAgB,EAAA;EA1HpB;IA8HI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc,EAAA;EAlIlB;IAsII,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc,EAAA;EA1IlB;IA6II,YAAY;IACZ,yBAAyB;IAGzB,aAAa;IAGb,uBAAuB;IAGvB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,sBAAsB;IAGtB,gBAAgB,EAAA;EAhKpB;IAmKI,yBAAyB,EAAA;EAnK7B;IAwKI,aAAa;IAGb,uBAAuB;IACvB,0BAA0B,EAAA;EA5K9B;IAgLI,yBAAyB;IACzB,8BAA8B,EAAA;EAjLlC;IAoLI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc,EAAA;EAxLlB;IA2LI,cAAc;IACd,iBAAiB,EAAA;EA5LrB;IA+LI,0BAA0B,EAAA;EA/L9B;IAkMI,yBAAyB,EAAA;EAlM7B;IAqMI,4BAA4B;IAC5B,yBAAyB;IACzB,uGAAuG;IACvG,sBAAsB,EAAA;EAxM1B;IA2MI,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc,EAAA;EA/MlB;IAkNI,yBAAyB;IACzB,0BAA0B,EAAA;EAnN9B;IAsNI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,0BAA0B,EAAA;EAG5B;IA9NF;MAgOM,iBAAiB,EAAA;IAhOvB;MAmOM,iBAAiB,EAAA;IAnOvB;MAsOM,4BAA4B,EAAA;IAtOlC;MAyOM,eAAe;MACf,iBAAiB,EAAA;IA1OvB;MA6OM,eAAe;MACf,iBAAiB,EAAA;IA9OvB;MAiPM,gBAAgB;MAChB,iBAAiB,EAAA;IAlPvB;MAqPM,4BAA4B,EAAA;IArPlC;MAwPM,eAAe;MACf,iBAAiB,EAAA,EAClB","sourcesContent":[".edm-apia-wrapper {\n  font-size: 62.5%;\n  font-size: 1.6rem;\n  background-color: #e9e9e9;\n  font-family: Arial, Tahoma;\n  margin: 0px;\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  p {\n    margin: 0;\n    padding: 0;\n  }\n  ul {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n  }\n  ul li a,\n  a {\n    text-decoration: none;\n  }\n  /*===========================  Start Main Page  ===========================*/\n  .main_page {\n    max-width: 700px;\n    margin: auto;\n    background-color: #ffffff;\n  }\n  .section_padding {\n    padding: 0px 35px;\n  }\n  .section_padding2 {\n    padding: 0px 50px;\n  }\n  .em_hide {\n    display: none;\n  }\n\n  .header_and_banner {\n    background-color: #011562;\n    background-image: url(https://tcncmpcardart.s3.ap-southeast-2.amazonaws.com/Tcncp/Suncorp/APIA/bg1.png);\n    background-size: cover;\n  }\n  .header {\n    padding: 5px 0px 5px 0px;\n  }\n  .header a img {\n    width: 167px;\n    height: auto;\n  }\n  .header p {\n    font-size: 15px;\n    line-height: 19px;\n    font-weight: normal;\n    font-style: normal;\n    color: #eb5d54;\n    padding: 8px 0 8px 0;\n  }\n\n  .banner_main img {\n    width: 100%;\n    height: auto;\n  }\n  .banner_contents {\n    padding: 34px 35px 35px 35px;\n  }\n  .banner_contents h3 {\n    font-size: 19px;\n    line-height: 23px;\n    font-weight: bold;\n    font-style: normal;\n    color: #00369c;\n  }\n  .banner_contents p {\n    font-size: 15px;\n    line-height: 19px;\n    font-weight: normal;\n    font-style: normal;\n    color: #000000;\n    padding: 14px 0px 0px 0px;\n  }\n\n  .redem_your_reward_main {\n    background-color: #d6d5dc;\n  }\n  .redem_your_reward_items_all {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: justify;\n    -ms-flex-pack: justify;\n    justify-content: space-between;\n    margin-top: 40px;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n  }\n  .redem_your_reward_title h2 {\n    font-size: 25px;\n    line-height: 30px;\n    font-weight: bold;\n    font-style: normal;\n    color: #00369c;\n    padding: 36px 0 0 0;\n    text-align: center;\n  }\n  .redem_your_reward_single {\n    text-align: center;\n    margin-bottom: 28px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n  .redem_your_reward_single p {\n    font-size: 12px;\n    line-height: 16px;\n    font-weight: normal;\n    font-style: normal;\n    color: #000000;\n    padding: 11px 0 0 0;\n    max-width: 125px;\n  }\n\n  .redem_your_reward_textbtn p {\n    font-size: 15px;\n    line-height: 22px;\n    font-weight: normal;\n    font-style: normal;\n    color: #000000;\n  }\n\n  .redem_your_reward_textbtn p span {\n    font-size: 15px;\n    line-height: 22px;\n    font-weight: bold;\n    font-style: normal;\n    color: #00369c;\n  }\n  .redem_your_reward_btn a {\n    width: 220px;\n    background-color: #00369c;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    font-size: 14px;\n    line-height: 20px;\n    font-weight: bold;\n    font-style: normal;\n    color: #ffffff;\n    padding: 13px 0 12px 0;\n    -webkit-transition: 0.2s;\n    -o-transition: 0.2s;\n    transition: 0.2s;\n  }\n  .redem_your_reward_btn a:hover {\n    background-color: #4a79d3;\n  }\n  .redem_your_reward_btn {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    padding: 30px 0px 40px 0px;\n  }\n\n  .footer_all_contents {\n    background-color: #d6d5dc;\n    border-top: 40px solid #e9e9e9;\n  }\n  .footer_contents_need_help p {\n    font-size: 15px;\n    line-height: 19px;\n    font-weight: normal;\n    font-style: normal;\n    color: #000000;\n  }\n  .footer_contents_need_help p span {\n    color: #00369c;\n    font-weight: bold;\n  }\n  .footer_contents_need_help p:first-child {\n    padding: 38px 0px 20px 0px;\n  }\n  .footer_contents_need_help p:last-child {\n    padding: 0px 0px 38px 0px;\n  }\n  .from_the_brighter_reward_team {\n    padding: 38px 35px 38px 35px;\n    background-color: #00369c;\n    background-image: url(https://tcncmpcardart.s3.ap-southeast-2.amazonaws.com/Tcncp/Suncorp/APIA/bg2.png);\n    background-size: cover;\n  }\n  .from_the_brighter_reward_team h2 {\n    font-size: 18px;\n    line-height: 22px;\n    font-weight: bold;\n    font-style: normal;\n    color: #ffffff;\n  }\n  .this_email_has_been {\n    background-color: #e9e9e9;\n    padding: 0px 45px 0px 45px;\n  }\n  .this_email_has_been p {\n    font-size: 11px;\n    line-height: 15px;\n    font-weight: normal;\n    font-style: normal;\n    color: #737373;\n    padding: 34px 0px 34px 0px;\n  }\n\n  @media all and (max-width: 575px) {\n    .section_padding {\n      padding: 0px 15px;\n    }\n    .section_padding2 {\n      padding: 0px 15px;\n    }\n    .banner_contents {\n      padding: 34px 15px 35px 15px;\n    }\n    .banner_contents h3 {\n      font-size: 17px;\n      line-height: 21px;\n    }\n    .redem_your_reward_title h2 {\n      font-size: 20px;\n      line-height: 24px;\n    }\n    .redem_your_reward_items_all {\n      margin-top: 40px;\n      padding: 0px 25px;\n    }\n    .from_the_brighter_reward_team {\n      padding: 34px 15px 34px 15px;\n    }\n    .from_the_brighter_reward_team h2 {\n      font-size: 16px;\n      line-height: 20px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
